import React, { useState, type FormEvent } from 'react';
import { NumberInput, RadioButtonGroupInput } from 'react-admin';
import { getSourceAndLabel, getClassificationFromSource } from '../PositionRateSettingsForm.utils';
import { RateSettingsDisplayHelper } from 'utils/displayHelpers/rate-settings';
import { useRateCalculations } from '../hooks/useRateCalculations';
import type { InheritedSettingsT } from '../../types/inheritedSettings.types';

type Props = {
  source: string;
  inheritedSettings: InheritedSettingsT;
};

const choices = [
  { id: 'lock_charge_rate', name: 'Lock Charge Rate' },
  { id: 'lock_professional_rate', name: 'Lock Professional Rate' },
];

export const MarginPercentInput = ({ source, inheritedSettings }: Props) => {
  const [isLockOptionVisible, setIsLockOptionVisible] = useState(false);
  const { watchedFields, handlers } = useRateCalculations({ source, inheritedSettings });

  const { source: inputSource, label, field } = getSourceAndLabel(source);
  const { tab } = getClassificationFromSource(source);
  const rateSettingsDisplayHelper = new RateSettingsDisplayHelper({ settings: inheritedSettings });
  const inheritedSettingsHash = rateSettingsDisplayHelper.getSettingsForClassification(tab);

  function handleLockOptionChange(event: FormEvent<HTMLDivElement>) {
    const value = (event.target as HTMLInputElement).value as
      | 'lock_professional_rate'
      | 'lock_charge_rate';
    handlers.handleLockTypeChange(value);
  }

  return (
    <>
      <NumberInput
        source={inputSource}
        label={label}
        helperText={String(inheritedSettingsHash?.[field] || '')}
        onFocus={() => setIsLockOptionVisible(true)}
        onChange={(event) => {
          const newValue = parseFloat(event.target.value);
          if (!isNaN(newValue)) {
            handlers.handleMarginChange(newValue);
          }
        }}
        disabled={field === 'total_margin_percent_w2'}
      />
      {isLockOptionVisible && (
        <RadioButtonGroupInput
          source={`${source}.lockedRateType`}
          choices={choices}
          value={watchedFields.lockedRateType}
          defaultValue="lock_charge_rate"
          label="Calculation Base"
          helperText="Select which rate will be fixed. The other will be automatically calculated based on the entered margin."
          onChange={handleLockOptionChange}
        />
      )}
    </>
  );
};
